export default __webpack_public_path__ + "static/media/moisturizer.c9b0108f.png";